// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"aee5b7c44e--tooltip--Rln6T","arrow":"aee5b7c44e--arrow--GMnRq"};